import React from 'react';
import ReactDOM from 'react-dom';
// import Next from 'next'
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/styles/_styles.scss'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
reportWebVitals();
